"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validations_1 = require("../../utils/validations");
function updateQuizModuleBestMark({ bestModuleMark: existingBestModuleMark }, { mark }) {
    if (!(0, validations_1.isNumber)(existingBestModuleMark)) {
        return mark;
    }
    return Math.max(mark, existingBestModuleMark);
}
exports.default = updateQuizModuleBestMark;
